import { useEffect, useState } from 'react';

import PubSub from 'pubsub-js';

import { logger } from '../../logger';
import { fetchFromUrl, getAppConfig, updateSessionStorage } from '../../utilities';
import * as types from '../../utilities/constants';

const useFooter = () => {
  const [config, setConfig] = useState({ footer: [], labels: {}, tableData: {} });
  const [isLoading, setIsLoading] = useState(true);
  const [expand, setExpand] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  PubSub.subscribe('forceUpdateFooter', () => setShowDetails(true));

  PubSub.subscribe('resetFooterToTheDefaultState', () => {
    setExpand(false);
    setShowDetails(false);
  });

  const toggleDetailsHandler = () => {
    const analyticsData = {
      element: {
        elementCategory: types.MORE_ON_THIS_SITE_ELEMENT_CATEGORY,
        name: !expand ? types.MORE_ON_THIS_SITE_ELEMENT_NAME_EXPAND : types.MORE_ON_THIS_SITE_ELEMENT_NAME_COLLAPSE
      },
      description: !expand ? types.MORE_ON_THIS_SITE_EXPAND_DESCP : types.MORE_ON_THIS_SITE_COLLAPSE_DESCP,
      event: types.MORE_ON_THIS_SITE_EVENT
    };
    PubSub.publish(types.DOCUMENTS_EVENT, analyticsData);
    setExpand(!expand);
  };

  const setAnalytics = (title, isInternal, row = { label: '', link: '' }) => {
    const { label, link } = row;
    if (title) {
      const analyticsData = {
        element: {
          elementCategory: types.LINK_ELEMENT_CATEGORY
        },
        description: types.LINK_DESCP,
        event: isInternal ? types.INTERNAL_LINK_EVENT : types.EXTERNAL_LINK_EVENT,
        click: {
          name: label,
          destination: link
        }
      };
      PubSub.publish(types.DOCUMENTS_EVENT, analyticsData);
    }
    if (isInternal) {
      const { host, path } = getAppConfig('server');
      setTimeout(() => {
        window.location.href = `${host}${path}${link}`;
      }, 0);
    }
  };

  const loadConfig = async () => {
    const locale = updateSessionStorage.getItem('locale');
    try {
      const configData = await fetchFromUrl(`${process.env.PUBLIC_URL}/models/${locale}/footer.json`);
      setConfig(configData);
    } catch (error) {
      logger.error(`Error loading footer.json for ${locale}`, error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadConfig();
  }, []);

  return {
    config,
    isLoading,
    expand,
    showDetails,
    toggleDetailsHandler,
    setAnalytics
  };
};

export default useFooter;
